import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Avatar from '../../components/Avatar';
import useDarkMode from '../../hooks/useDarkMode';
import moment from 'moment';
import 'moment/locale/ko';
moment.locale('ko')
import ImageList from "./ImageList"
import FileList from "./FileList"
import config from "../../config"
import Spinner from '../../components/bootstrap/Spinner';
import Popovers from '../../components/bootstrap/Popovers';

export const ChatListItem = ({
	src,
	srcSet,
	className,
	isOnline,
	color,
	size,
	name,
	duty,
  	department,
	latestMessage,
	unreadMessage,
	isActive,
	lastSeenTime,
  	usersCount,
	rootType,
	isTyping,
	...props
}) => {
	const { darkModeStatus } = useDarkMode();
	return (
		// eslint-disable-next-line react/jsx-props-no-spreading
 		<div className={classNames('col-12 cursor-pointer', className)} {...props}>
			<div
				className={classNames(
					'd-flex align-items-center message-wrap',
					'p-1 rounded-2',
					'transition-base',
					{
						'bg-l25-info-hover': !darkModeStatus,
						'bg-lo50-info-hover': darkModeStatus,
						'active': isActive,
					},
				)}>
				<ChatAvatar
					src={src}
					srcSet={srcSet}
					isOnline={isOnline}
					unreadMessage={unreadMessage}
					color={color}
					size={size}
					className='me-3'
				/>				
        <div className='message-mid'>
          <div className='message-mid-info'>
            { rootType === 'd' && <span><i className='ri-message-2-line'></i></span>} {/* 1:1 채팅*/}
            { rootType === 'p' && <span><i className='ri-group-line'></i></span>} {/* 그룹 채팅*/}
            <span className='usercount'>{usersCount}</span>{/** 참여자 수 */}
            <span className='ms-1' dangerouslySetInnerHTML={{__html: name }}></span>
            <span className='wrap-duty'>{ duty }</span>            
            <span className='wrap-duty'>{ department }</span>          
          </div>
          { !isTyping && <div className='message-mid-text'><span>{latestMessage ? latestMessage : <span className='text-muted opa-50'>#대화를 시작하지 않았습니다.</span>}</span></div> }						
        </div>					
        <div className='message-date'>
        {lastSeenTime && (
            <small
              className={classNames(                
                {
                  'bg-l10-info': !darkModeStatus,
                  'bg-lo25-info': darkModeStatus,
                },
              )}>
              {lastSeenTime}
            </small>
          )}
          <div className='position-relative my-1'>            
            {unreadMessage > 0 && (
              <span className='chat-count'>
                {unreadMessage} <span className='visually-hidden'>unread messages</span>
              </span>
            )} {/** 안읽은 메시지 수 */}           
          </div>
        </div>
			</div>
		</div>
	);
};
// ChatListItem.propTypes = {
// 	src: PropTypes.string.isRequired,
// 	srcSet: PropTypes.string,
// 	className: PropTypes.string,
// 	isOnline: PropTypes.bool,
// 	color: PropTypes.string,
// 	size: PropTypes.number,
// 	name: PropTypes.string.isRequired,
// 	surname: PropTypes.string.isRequired,
// 	latestMessage: PropTypes.string,
// 	unreadMessage: PropTypes.number,
// 	isActive: PropTypes.bool,
// 	lastSeenTime: PropTypes.string,
// };
ChatListItem.defaultProps = {
	srcSet: null,
	className: null,
	isOnline: false,
	color: 'primary',
	size: 28,
	latestMessage: null,
	unreadMessage: null,
	isActive: false,
	lastSeenTime: null,
};

export const ChatHeader = ({ to }) => {
	return (
		<>
			<strong className='me-2'>To:</strong>
			{to}
		</>
	);
};
ChatHeader.propTypes = {
	to: PropTypes.string.isRequired,
};

export const ChatMessages = ({ message, isReply, isBlockKit, allUserObject, unreadMessage, ...props }) => {
	return (
		// eslint-disable-next-line react/jsx-props-no-spreading
		<div className='chat-messages' {...props}>			
			{isBlockKit && 
					<div width="240" className="block-kit" key={message._id}>
						{JSON.parse(message.msg).blocks.map((b, i2) => (
							<div key={i2} className="block-kit-head">
								{b.type === 'header' &&
									<div className="block-mg">
										<h2 className="block-kit-title">{b.text}</h2>
									</div>
								}
								{b.type === 'text' &&
									<div className="block-lg">
										<div className="block-link">
											{
												b.inlines &&
												<>
													<b><span className="red">{b.text} </span></b>
													{/* <a href="#">sample</a> */}
												</>
											}
											{
												!b.inlines &&
												<span className="black">{b.text} </span>
											}
										</div>
									</div>
								}
								{b.type === 'divider' &&
									<div className="block-mg">
										<hr />
									</div>
								}
								{b.type === 'button' &&
									<div className="block-lg">
										<div className="block-tm">
											<button onClick={() => {
												window.open(b.value, '_blank')
											}} className="block-btn">{b.text}</button>
										</div>
									</div>
								}
								{b.type === 'image_link' &&
									<div className="block-mg">
										<div>
											<img src={b.url} />
										</div>
									</div>
								}
								{b.type === 'action' &&
									<div className="block-lg">
										<div className="block-flex">
											<div>
												<button className="block-btn-true">승인</button>
											</div>
											<div>
												<button className="block-btn-false">반려</button>
											</div>
										</div>
									</div>
								}
								{b.type === 'section' &&
									<div className="block-lg">
										<div className="block-flex">
											<div>
												<div>
													카카오엔터프라이즈의업무용메신저<b>카카오워크</b>
												</div>
											</div>
											<div>
												<div>
													이미지삽입
												</div>
											</div>
										</div>
									</div>
								}
								{b.type === 'description' &&
									<div className="block-lg">
										<div className="block-flex">
											<div className="block-flex-title">일시</div>
											<div className="block-flex-text">2020년 9월 16일 7시</div>
										</div>
									</div>
								}
							</div>
						))}
					</div>
			}
			{/* 대화풍선 */}
      {(!isBlockKit && !message.t) &&
			(<div className='chat-user-info'>
				<div className='name'>{allUserObject[message?.u.username].name}</div>
				<div className='time'>{moment(message.ts.$date).format('HH:mm:ss')}</div>
			</div>)}
      {message.file &&
      message.file.type.indexOf("image") > -1 && (
        <ImageList images={message.attachments}
          className={classNames({ 'chat-group-reply': isReply })} 
          />
      )}
      {message.file &&
      message.file.type.indexOf("image") < 0 && (
        <FileList files={message.attachments} 
          className={classNames({ 'chat-group-reply': isReply })} 
        />
      )}
			{!isBlockKit && !message.file &&
        <>
          
          {!message.t && 
          <div
            key={message._id}
            className={classNames('chat-message', { 'chat-message-reply': isReply })}>
            {message.msg}
            {/* 메세지 읽은 개수 */}
            <span className='read-count'>
              <span>{unreadMessage}</span>
            </span>
          </div>
          }
        </>
			}
		</div>
	);
};

// ChatMessages.propTypes = {
// 	// eslint-disable-next-line react/forbid-prop-types
// 	messages: PropTypes.arrayOf(
// 		PropTypes.shape({
// 			id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
// 			message: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
// 		}),
// 	).isRequired,
// 	isReply: PropTypes.bool,
// };
ChatMessages.defaultProps = {
	isReply: false,
};

export const ChatAvatar = ({
	src,
	srcSet,
	className,
	color,
	username,
	allUserObject,
	unreadMessage,
	isOnline,
	size,
	...props
}) => {
	return (
		<Popovers
			title={allUserObject && allUserObject[username] ? allUserObject[username].DepartmentName 
				+ ' ' + allUserObject[username].duty : ''}
			trigger='hover'
			placement="top"
		>
			<div
				className={classNames('chat-avatar', className)}
				// eslint-disable-next-line react/jsx-props-no-spreading
				{...props}>

				<div className='position-relative'>
					{src && <Avatar srcSet={srcSet} src={src} size={size} color={color} />}
					{/* {unreadMessage > 0 && (
						<span className='position-absolute chat-count'>
							{unreadMessage} <span className='visually-hidden'>unread messages</span>
						</span>
					)}  */}
					{isOnline && (
						<span className='position-absolute top-85 start-85 translate-middle badge border border-light rounded-circle bg-success p-2'>
							<span className='visually-hidden'>Online user</span>
						</span>
					)}
          {!isOnline && (
						<span className='position-absolute top-85 start-85 translate-middle badge border border-light rounded-circle bg-light p-2 shadow-sm'>
							<span className='visually-hidden'>offline user</span>
						</span>
					)}
				</div>
			</div>
		</Popovers>
	);
};
// ChatAvatar.propTypes = {
// 	src: PropTypes.string,
// 	srcSet: PropTypes.string,
// 	className: PropTypes.string,
// 	color: PropTypes.string,
// 	unreadMessage: PropTypes.number,
// 	isOnline: PropTypes.bool,
// 	size: PropTypes.number,
// };
ChatAvatar.defaultProps = {
	src: null,
	srcSet: null,
	className: null,
	color: null,
	unreadMessage: null,
	isOnline: false,
	size: 28,
};

export const ChatGroup = ({ message, isReply, daytitle, allUserObject, unreadMessage, ...props }) => {
	const _Avatar = (
		<>
			<ChatAvatar
				src={config.CHAT_URL + '/avatar/' + message.u.username}
				srcSet={message.u.srcSet}
				username={message.u.username}
				allUserObject={allUserObject}
				name={message.u.name}
				surname={message.u.surname}
				isOnline={false}
				color={'danger'}
				unreadMessage={0}
			/>
		</>
	);

	return (
		<div className={classNames('chat-group', { 'chat-group-reply': (isReply && !message.isBlockKit) })} /*{...props}*/>
			{ daytitle && <div className='chat-day'>{daytitle}</div> }
			{(!isReply && !message.isBlockKit && !message.t) && _Avatar}
			<ChatMessages message={message} isReply={isReply} isBlockKit={message.isBlockKit} allUserObject={allUserObject} unreadMessage={unreadMessage}/>
			{(isReply && !message.isBlockKit && !message.t) && _Avatar}
			{message.t === 'r' && 
			<div
				className={classNames('mesg-info')}>
				<span>채팅방 제목이 {message.msg}로 변경 되었습니다.</span>
				<span>({moment(message._updatedAt.$date).format("HH:mm:ss")})</span>
			</div>
			}
			{message.t === 'rm' && 
			<div
				className={classNames('mesg-info')}>
				<span> 메시지가 삭제 되었습니다.</span>
				<span>({moment(message._updatedAt.$date).format("HH:mm:ss")})</span>
			</div>
			}
			{(message.t === 'added-user-to-team' || message.t === 'au') && 
			<div
				className={classNames('mesg-info')}>
				<span><span>{allUserObject[message.u.username].name}</span> 님이<span> {allUserObject[message.msg].name} </span>님을 초대 하였습니다.</span>
				<span>({moment(message._updatedAt.$date).format("HH:mm:ss")})</span>
			</div>
			}
			{(message.t === 'ult' || message.t === 'ul') && 
			<div
				className={classNames('mesg-info')}>
				<span><span>{allUserObject[message.msg].name}</span>님이 나갔습니다.</span>
				<span>({moment(message._updatedAt.$date).format("HH:mm:ss")})</span>
			</div>
			}
			{message.t === 'uj' && 
			<div
				className={classNames('mesg-info')}>
				<span><span>{message.msg}</span>님이 들어왔습니다.</span>
				<span>({moment(message._updatedAt.$date).format("HH:mm:ss")})</span>
			</div>
			}
			{message.t === 'ru' && 
			<div
				className={classNames('mesg-info')}>
				<span><span>{message.msg}</span>님이 강제 퇴장 되었습니다.</span>
				<span>({moment(message._updatedAt.$date).format("HH:mm:ss")})</span>
			</div>
			}
			{message.t === 'subscription-role-added' && 
			<div
				className={classNames('mesg-info')}>
				<span><span>{message.msg}</span>님이 방장에 임명 되었습니다.</span>
				<span>({moment(message._updatedAt.$date).format("HH:mm:ss")})</span>
			</div>
			}
			{message.t === 'subscription-role-removed' && 
			<div
				className={classNames('mesg-info')}>
				<span><span>{message.msg}</span>님이 방장에서 해임 되었습니다.</span>
				<span>({moment(message._updatedAt.$date).format("HH:mm:ss")})</span>
			</div>
			}
			</div>
	);
};
// ChatGroup.propTypes = {
// 	isReply: PropTypes.bool,
// 	message: PropTypes.objectOf(
// 		PropTypes.shape({
// 			id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
// 			message: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
// 		}),
// 	).isRequired,
// 	isOnline: PropTypes.bool,
// 	color: PropTypes.string,
// 	user: PropTypes.shape({
// 		src: PropTypes.string,
// 		srcSet: PropTypes.string,
// 		username: PropTypes.string,
// 		name: PropTypes.string,
// 		surname: PropTypes.string,
// 		isOnline: PropTypes.bool,
// 		color: PropTypes.string,
// 	}),
// };
ChatGroup.defaultProps = {
	isReply: false,
	isOnline: false,
	color: null,
};

const Chat = ({ children, className }) => {
	return (
		// eslint-disable-next-line react/jsx-props-no-spreading
		<div className={classNames('chat-container', className)}>{children}</div>
	);
};
// Chat.propTypes = {
// 	children: PropTypes.node.isRequired,
// 	className: PropTypes.string,
// };
Chat.defaultProps = {
	className: null,
};

export default Chat;
